import axios from '@axios'

const BASE = '/workspace/storage'

export default {
  // NAS configuration
  getConfig: () => axios.get(`${BASE}/config`),
  saveConfig: data => axios.put(`${BASE}/config`, data),
  testConnection: () => axios.post(`${BASE}/config/test-connection`),
  toggleNas: () => axios.post(`${BASE}/config/toggle`),
  deleteConfig: () => axios.delete(`${BASE}/config`),

  // Sync management
  getSyncStatus: () => axios.get(`${BASE}/sync/status`),
  getSyncFiles: (params = {}) => axios.get(`${BASE}/sync/files`, { params }),
  getSyncLogs: (params = {}) => axios.get(`${BASE}/sync/logs`, { params }),
  retrySync: () => axios.post(`${BASE}/sync/retry`),
  triggerSync: () => axios.post(`${BASE}/sync/trigger`),

  // Usage
  getUsage: () => axios.get(`${BASE}/usage`),
}
